import { Record } from 'immutable';
import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import type { FilterDefinitionType } from '../definitions';
import type {
  SharedFilterFields,
  SharedFilterMethods,
} from '../../types/filter-value-types';
import NameRecord from '../NameRecord';

export type RangeType = [number, number];

const keys: Fields = {
  filterName: new NameRecord(),
  values: [0, 0],
  minMax: [0, 0],
  type: FilterDefinitionTypeConstants.RANGE,
};

export interface Fields extends SharedFilterFields {
  values: RangeType;
  minMax: RangeType;
  type: FilterDefinitionTypeConstants.RANGE;
}

export default class RangeFilterRecord extends Record<Fields>(keys)
  implements SharedFilterMethods {
  constructor(values?) {
    super(values);

    if (values && values.filterDefinition) {
      const fd = values.filterDefinition;
      return this.merge({
        filterName: fd.getNameRecord(),
        minMax: [fd.getMin(), fd.getMax()],
      });
    }
  }

  getFilterKey() {
    return this.filterName.getName();
  }

  getType() {
    return this.type;
  }

  getName() {
    return this.filterName.getName();
  }

  getLabel() {
    return this.filterName.getLabel();
  }

  getTranslationKey(): string {
    return this.filterName.getTranslationKey() || '';
  }

  getValues(): RangeType {
    return this.values;
  }

  add(newRange: RangeType) {
    return this.set('values', newRange);
  }

  removeValue(side?: 'min' | 'max') {
    switch (side) {
      case 'min':
        return this.set('values', [this.minMax[0], this.values[1]]);
      case 'max':
        return this.set('values', [this.values[0], this.minMax[1]]);
      default:
        return null;
    }
  }

  updateFromDefinition(def: FilterDefinitionType): this {
    return this.set('filterName', def.getNameRecord());
  }
}
